module.exports = __webpack_public_path__ + "static/media/qrcode.1104bd59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/qrcode.jpg
// module id = 570
// module chunks = 0